import { render, staticRenderFns } from "./xxb.vue?vue&type=template&id=2738c7ac&scoped=true&"
import script from "./xxb.vue?vue&type=script&lang=js&"
export * from "./xxb.vue?vue&type=script&lang=js&"
import style0 from "./xxb.vue?vue&type=style&index=0&id=2738c7ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738c7ac",
  null
  
)

export default component.exports